<template>
  <div class="style-guide">
    <!-- <div>
      Location (dropdown: Irvine, Lake Forest) | Range Type (dropdown: daily, weekly, monthly, yearly) | Date Picker 1 (start) | Date Picker 2 (end)
    </div> -->
    <!-- <DataGrid :columns="columns" :items="items" :filterable="true" /> -->
    <v-container>
      <h2>Dashboard Filters Area <small v-if="isLoggedIn">(<router-link to="/">go back home</router-link>)</small></h2>
      <FilterArea @locationUpdated="locationUpdatedFunction" @rangeUpdated="rangeUpdatedFunction" @startDateUpdated="startDateUpdatedFunction"  @endDateUpdated="endDateUpdatedFunction" :location="location" :startDate="startDate" :endDate="endDate"/>
    </v-container>
    <v-container>
      <v-layout row>
        <v-flex xs6>
          <p>Location Event Data: {{ location }}</p>
          <p>Range Event Data: {{ range }}</p>
        </v-flex>
        <v-flex xs6>
          <p>Start Date Event Data: {{ startDate }}</p>
          <p>End Date Event Data: {{ endDate }}</p>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <h2>Numbers Component Area</h2>
      <v-layout row wrap>
        <v-flex xs12 lg3>
          <DashboardNumbers :title="title1" :number="number1" :percent="percent1" :url="url1" @urlRequested="urlRequestedFunction"/>
        </v-flex>
        <v-flex xs12 lg3>
          <DashboardNumbers :title="title2" :number="number2" :percent="percent2" :url="url2" @urlRequested="urlRequestedFunction"/>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 lg3>
          <DashboardNumbers :title="title3" :number="number3" :percent="percent3" :url="url3" @urlRequested="urlRequestedFunction"/>
        </v-flex>
        <v-flex xs12 lg3>
          <DashboardNumbers :title="title4" :number="number4" :percent="percent4" :url="url4" @urlRequested="urlRequestedFunction"/>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <h2>Data Grid</h2>
      <v-layout>
        <DataGrid :columns="columns" :items="items" :filterable="true"/>
      </v-layout>
    </v-container>
    <v-container>
      <h2>User Profile Area</h2>
      <UserProfile :imageUrl="imageUrl" :showForm="showForm" :firstName="firstName" :lastName="lastName" :phone="phone" :email="email" :rate="rate"/>
    </v-container>
    <v-container>
      <h2>Service Time Area</h2>
      <ServiceTime :clientName="stClientName" :time="stTime" :techName="stTechName" />
    </v-container>
    <v-container>
      <h2>Title Component Area</h2>
      <Title :isLarge="boolIsLarge" :text="stText" />
    </v-container>
    <v-container>
      <h2>Multiuse Button Area</h2>
      <Button :color="btnColor" :showIcon="btnShowIcon" :text="btnText" :icon="btnIcon" :iconPlacement="btnIconPlacement" :textAlignment="btnTextAlignment" :width="btnWidth" />
    </v-container>
    <v-container>
      <h2>Appointment Area</h2>
      <Appointment :id="apptId" :date="apptDate" :location="apptLocation" :isCompact="false" :exists="apptExists" />
      <Appointment :id="apptId" :date="apptDate" :location="apptLocation" :isCompact="true" :exists="apptExists" />
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DataGrid from '@/core/DataGrid.vue'
import FilterArea from '@/components/FilterArea.vue'
import DashboardNumbers from '@/components/DashboardNumbers.vue'
import UserProfile from '@/components/UserProfile.vue'
import ServiceTime from '@/components/ServiceTime.vue'
import Title from '@/components/Title.vue'
import Button from '@/components/Button.vue'
import Appointment from '@/components/Appointment.vue'

export default {
  name: 'dashboard',
  components: {
    DataGrid,
    FilterArea,
    DashboardNumbers,
    UserProfile,
    ServiceTime,
    Title,
    Button,
    Appointment
  },
  data: () => {
    return {
      location: 'Lake Forest',
      range: 'Range not yet chosen',
      startDate: '2018-06-24',
      endDate: '2018-07-04',
      title1: 'New Tickets',
      title2: 'Closed Today',
      title3: 'Agent Replies',
      title4: 'New Replies',
      number1: 24,
      number2: 12,
      number3: 52,
      number4: 7,
      percent1: 12,
      percent2: -12,
      percent3: 12,
      percent4: -12,
      url1: 'tech',
      url2: 'random',
      url3: 'url3',
      url4: 'url4',
      imageUrl: require('../../assets/chris.jpg'),
      showForm: false,
      firstName: 'Ryan',
      lastName: 'O\'Boyle',
      phone: '(949) 838-9929',
      email: 'ryanoboyles_email@gmail.com',
      rate: '35',
      stClientName: 'Ryan Wells',
      stTime: '30',
      stTechName: 'vincent',
      boolIsLarge: false,
      stText: 'top',
      btnColor: 'primary',
      btnText: 'hello',
      btnIcon: 'add',
      btnShowIcon: true,
      btnIconPlacement: 'left',
      btnTextAlignment: 'center',
      btnWidth: '85',
      apptId: 'a360adb0-48b0-e611-80c0-002219cb68f9',
      apptDate: '2018-07-22T05:12:00-10:00',
      apptLocation: {
        name: 'Lake Forest',
        address: '23024 Lake Forest Drive',
        city: 'Irvine',
        state: 'CA',
        zip: '12345'
      },
      apptExists: true,

      // data grid options:
      columns: [
        {
          text: 'Name',
          align: 'left',
          sortable: true
        },
        {
          text: 'Phone',
          sortable: false
        },
        {
          text: 'Email',
          sortable: false
        }
      ],
      items: [
        {
          Name: 'Ryan Wells',
          Phone: '949-236-7402',
          Email: 'ryanwellsconsulting@gmail.com'
        },
        {
          Name: 'John Smith',
          Phone: '212-555-1289',
          Email: 'jsmith@mail.com'
        },
        {
          Name: 'Frank Mason',
          Phone: '949-458-7489',
          Email: 'fmason@mail.com'
        },
        {
          Name: 'George Jones',
          Phone: '714-587-4589',
          Email: 'gjones@mail.com'
        },
        {
          Name: 'Janice Griffith',
          Phone: '818-258-9632',
          Email: 'jgriffith@mail.com'
        },
        {
          Name: 'Emily Clark',
          Phone: '657-258-1489',
          Email: 'eclark@mail.com'
        },
        {
          Name: 'Raul Sanchez',
          Phone: '568-417-8912',
          Email: 'rsanchez@mail.com'
        },
        {
          Name: 'Magnus Larsson',
          Phone: '310-196-4589',
          Email: 'mlarsson@mail.com'
        },
        {
          Name: 'Jennifer Thomas',
          Phone: '323-456-4589',
          Email: 'jthomas@mail.com'
        },
        {
          Name: 'Maxwell Peters',
          Phone: '714-859-2418',
          Email: 'mpeters@mail.com'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn'
    })
  },
  methods: {
    locationUpdatedFunction (val) {
      this.location = val
    },
    rangeUpdatedFunction (val) {
      this.range = val
    },
    startDateUpdatedFunction (val) {
      this.startDate = val
    },
    endDateUpdatedFunction (val) {
      this.endDate = val
    },
    urlRequestedFunction (url) {
      this.$router.push(url)
    }
  }
}
</script>

<style scoped lang="scss">
.style-guide {
  h2 {
    margin-bottom: 20px;
  }
}
</style>
